import { initialState, ServiceGroupRatesState, serviceGroupRatesAdapter } from './service-group-rate.interfaces';
import * as fromServicegroupRates from './service-group-rate.actions';
import { ActionReducer, MetaReducer } from '@ngrx/store';

export function reducer(
  state: ServiceGroupRatesState,
  action: fromServicegroupRates.ServicegroupRatesAction
): ServiceGroupRatesState {
  switch (action.type) {
    case fromServicegroupRates.GET_SERVICE_GROUP_RATES_FROM_SERVER_SUCCESS: {
      return {
        ...serviceGroupRatesAdapter.addMany(action.payload.serviceGroupRates, state)
      };
    }

    default: {
      return state;
    }
  }
}

export function serviceGroupRateStateHydration(
  reducer: ActionReducer<ServiceGroupRatesState>
): ActionReducer<ServiceGroupRatesState> {
  return function(
    state: ServiceGroupRatesState,
    action: any,
    metaReducer: string = 'stateHydration'
  ): ServiceGroupRatesState {
    if (state === undefined) {
      console.log('populate service group rate state from local storage?');
      let serviceGroups: any = localStorage.getItem('service-group-rates-state');
      state = serviceGroups ? JSON.parse(serviceGroups) : initialState;
    }
    const newState = reducer(state, action);
    // if (action.feature === 'labourOperations.serviceGroupRates' && action.triggerStorageSync) {
    //   localStorage.setItem('service-group-rates-state', JSON.stringify(newState));
    // }

    return newState;
  };
}

export const metaReducers: MetaReducer<ServiceGroupRatesState>[] = [serviceGroupRateStateHydration];
